"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MatomoProvider = exports.MatomoContext = void 0;
var _react = require("react");
var _MatomoConfig = require("./MatomoConfig");
var _jsxRuntime = require("react/jsx-runtime");
const initiellInstans = {
  opprettet: false,
  leggTilInstruksjon: () => undefined
};
const MatomoContext = exports.MatomoContext = /*#__PURE__*/(0, _react.createContext)({
  instans: initiellInstans
});

/**
 * En provider som initialiserer Matomo og setter opp et standard oppsett for måling av webstatistikk som inkluderer sidevisninger og lenkeklikk.
 * For å sende custom eventer, manuelt trigge sidevisninger eller legge til Matomo instruksjoner bruk useMatomo hooken.
 *
 * Merk: Matomo konfigureres kun en gang ved første render. Endring av props i etterkant har derfor ingen effekt. Om du trenger å utsette konfig, bruk prop-en utsettKonfig
 * @param {boolean} [siteID] - Matomo site id som sporingen skal gå til
 * @param {boolean} [sporTilHelhetligMåling=true] - Automatisk send data til Helhetlig Måling site id i tillegg til din egen site id
 * @param {boolean} [erSamtykkeGitt=false] - Brukes for å implementere egen logikk for samtykke til sporing.
 * Default er false og det gjøres da en sjekk av cookien skatteetaten.statistikk i stedet.
 * @param {boolean} [utsettKonfig] - Utsett konfig av Matomo. Brukes ved async henting av andre props, slik som site id og miljø
 */
const MatomoProvider = ({
  siteID,
  sporTilHelhetligMåling = true,
  erSamtykkeGitt = false,
  miljø,
  utsettKonfig,
  children
}) => {
  let matomoInstans = initiellInstans;
  if (!utsettKonfig) {
    const nyInstans = (0, _MatomoConfig.konfigurerMatomo)(siteID, sporTilHelhetligMåling, erSamtykkeGitt, miljø);
    if (nyInstans) {
      matomoInstans = nyInstans;
    }
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(MatomoContext.Provider, {
    value: {
      instans: matomoInstans
    },
    children: children
  });
};
exports.MatomoProvider = MatomoProvider;